import React, { useEffect, useState, useCallback } from "react";
import { getDecodedHtml } from "utils/getDecodedHtml";
import TabcordionVideo from "./TabcordionVideo";
import ButtonIcon from "components/utility/button/ButtonIcon";
import TooltipButton from "components/utility/tooltip/TooltipButton";
import { v1 as uuidv1 } from "uuid";

const TabcordionMediaCard = ({ tab }) => {
	const [mediaDirection, setMediaDirection] = useState("right");

	const getMediaDirection = useCallback(() => {
		if (window.innerWidth >= 768) {
			setMediaDirection("right");
		} else {
			setMediaDirection("left");
		}
	}, []);

	useEffect(() => {
		const resizeObserver = new ResizeObserver(() => {
			getMediaDirection();
		});
		resizeObserver.observe(document.getElementsByTagName("body")[0]);
		return () => {
			resizeObserver.unobserve(document.getElementsByTagName("body")[0]);
		};
	}, [getMediaDirection]);

	return (
		<div className="tabcordion--media-card">
			{tab.mediaTitle !== "" ? (
				<div
					className="tabcordion--media-card-title t-body-sm-heavy"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(tab.mediaTitle) }}
				/>
			) : null}
			{tab.mediaDescription !== "" ? (
				<div
					className="tabcordion--media-card-description t-body-sm"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(tab.mediaDescription) }}
				/>
			) : null}

			{tab.type === "Two-Column-Image" ? (
				<img className="tabcordion--media-card-image" src={tab.image} alt={tab.alt} />
			) : (
				<TabcordionVideo vid={tab.video} image={tab.image} alt={tab.alt} />
			)}

			<div className="tabcordion--media-card-little">
				{tab.mediaFootnote ? (
					<div
						className="tabcordion--media-card-footnote t-body-xs"
						dangerouslySetInnerHTML={{ __html: getDecodedHtml(tab.mediaFootnote) }}
					/>
				) : null}
				{tab.mediaInfo ? (
					<TooltipButton
						className="elementicon"
						id={uuidv1()}
						content={tab.mediaInfo}
						position="top"
						tooltipPosition={mediaDirection}
						clickable={true}
					>
						<ButtonIcon className="elementicon-i" type="info-popup" color="teal" isButton={false} />
					</TooltipButton>
				) : null}
			</div>
		</div>
	);
};

export default TabcordionMediaCard;
